import { isEmpty } from 'validate.js';

/**
 * Converts given string to title case
 * Eg:
 * IN PROGRESS => In Progress
 *
 * @param {String} str string to convert
 * @returns String
 */
export const toTitleCase = (str) => {
  if (isEmpty(str)) return str;
  return str.toLowerCase().replace(/\b(\w)/g, (s) => s.toUpperCase());
};

/**
 * Returns string in title case from camel case
 * Eg: 
 * helloWorld -> Hello World
 * 
 * @param {String} camelCase 
 * @returns String
 */
export const camelToTitleCase = (camelCase) =>
  camelCase
    .replace(/([A-Z])/g, (match) => ` ${match}`)
    .replace(/^./, (match) => match.toUpperCase())
    .trim();

export const getFirstCharacterCapitalized = (str) => {
  if (isEmpty(str)) return 'C'; // C for customer
  return str.charAt(0).toUpperCase();
};

/**
 * Returns file extension for given string
 * @param {String} str 
 * @returns String
 */
export const getFileExtension = (str) => {
  if (isEmpty(str)) return '';
  return str.split('.').pop();
};

/**
 * Returns Title for given pathname
 * Eg: /contact-us -> Contact Us | AskOkey
 * @param {String} pathname
 * @returns String
 */
export const getTitleForSlug = (pathname) => {
  if (isEmpty(pathname)) return '';
  
  let str = pathname.replace(/-/g, ' ');
  str = str.replace('/', '');
  str += ' | AskOkey';
  str = toTitleCase(str);
  return str;
};


/**
 * Returns a hyphenated string
 * Eg:
 * input: 'How are YOU'
 * output: 'how-are-you'
 * 
 * @param str - str is a string parameter that represents the input string that needs to be hyphenated.
 * @returns String
 */
export const getHyphenatedString = (str) => {
  if (!str || str.length === 0) return '';
  return str.replace(/ +/g, '-').toLowerCase();
};

/**
 * Returns a string where the first letter of each word is capitalized
 * Eg:
 * input: 'askokey navy socks'
 * output: 'Askokey Navy Socks'
 * 
 * @param str - string to be capitalized
 * @returns String
 */
export const capitalizeFirstLetterOfWords = (str) => {
  return str.replace(/\b\w/g, (char) => char.toUpperCase());
};

/**
 * Returns a string where the first letter is made lowercase
 * Eg:
 * input: 'AskokeyNavySocks'
 * output: 'askokeyNavySocks'
 * 
 * @param str - str to be processed
 * @returns String
 */
export const makeFirstLetterLowercase = (str) => {
  if (!str) return str; // Handle empty or undefined strings
  return str.charAt(0).toLowerCase() + str.slice(1);
};